import script from "./ScrollingMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollingMenu.vue?vue&type=script&setup=true&lang=js"

import "./ScrollingMenu.vue?vue&type=style&index=0&id=4c49fc8b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c49fc8b"]])

export default __exports__